import { render, staticRenderFns } from "./AddCustomBarcode.vue?vue&type=template&id=2131a163"
import script from "./AddCustomBarcode.vue?vue&type=script&lang=js"
export * from "./AddCustomBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports